<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <!-- Refresh Button -->
            <download-button title="Download Template" @download="downloadTemplate()"></download-button>
            <refresh-button @refresh="refreshData()"></refresh-button>

            <add-button v-if="$moduleAccess('add_farematrix')" @add="openAddDialog"></add-button>
            <!-- Dialog for Add, View Edit  -->
            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              :disableSave="disabledSave"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container fluid>
                <v-layout justify-center>
                  <v-flex md5>
                    <!-- Insert View Dialog Content BELOW-->
                    <details-container
                      ref="detailsRef"
                      :data="viewData"
                      :routes="routes"
                      :vehicleLayouts="vehicleLayouts"
                      :readonly="dialogType === 'view'"
                    />
                  </v-flex>
                  <v-flex md4 v-if="uploadItems.length > 0">
                    <jti-expansion-panel panelName="Max Fares">
                      <v-container class="py-0">
                        <v-text-field
                          label="MAX REGULAR FARE"
                          :value="$amountInPeso(this.$store.state.fareMatrixItems[this.$store.state.fareMatrixItems.length - 1].regular_fare)"
                          :readonly="true"
                        ></v-text-field>
                        <v-text-field
                          label="MAX DISCOUNTED FARE"
                          :value="$amountInPeso(this.$store.state.fareMatrixItems[this.$store.state.fareMatrixItems.length - 1].discounted_fare)"
                          :readonly="true"
                        ></v-text-field>
                      </v-container>
                    </jti-expansion-panel>
                  </v-flex>
                </v-layout>
                <v-layout v-if="dialogType==='add' || dialogType==='edit'" justify-center>
                  <upload-csv @selectFile="uploadCsv"></upload-csv>
                </v-layout>
                <v-layout>
                  <fare-matrix-data
                    ref="fareMatrixDataRef"
                    v-on:setQueryParamsLimit="setDataQueryLimit"
                    v-on:nextClickFM="nextClickFareMatrix"
                    v-on:backClickFM="backClickFareMatrix"
                    v-on:editClickFM="editItem"
                    @location="stopLocation"
                    :viewData="viewData"
                    :uploadHeaders="uploadHeaders"
                    :uploadItems="uploadItems"
                    :dialogType="dialogType"
                    :page="page"
                  ></fare-matrix-data>
                </v-layout>
              </v-container>
            </action-dialog>

            <customize-dialog
              title="Stops"
              action="plot"
              color="red"
              :dialog="customizeDialog"
              @saveDialog="saveDialog"
              @closeDialog="closeMapDialog"
              :loading="dialogLoading"
              showSave
              :disableSave="disableSaveStopMap()"
            >
              <fare-matrix-map
                :center="center"
                :zoom="zoom"
                :postSelected="null"
                ref="mapMatrix"
                :data="mapPosts"
                v-on:selectPost="selectPost"
                v-on:setLocation="setLocation"
                v-on:setRadius="setRadius"
              ></fare-matrix-map>
            </customize-dialog>

            <v-dialog v-model="editDialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">Edit Item</span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <v-text-field v-model="editedItem.name" label="Name"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field v-model="editedItem.post" label="Post" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field v-model="editedItem.province" label="Province"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.regular_fare"
                            label="Regular Fare"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.discounted_fare"
                            label="Discounted Fare"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.special_fare"
                            label="Special Fare"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.special_discounted_fare"
                            label="Special Discounted Fare"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.special_fare_2"
                            label="Special Fare 2"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.special_discounted_fare_2"
                            label="Special Discounted Fare 2"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.special_fare_3"
                            label="Special Fare 3"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.special_discounted_fare_3"
                            label="Special Discounted Fare 3"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.special_fare_4"
                            label="Special Fare 4"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.special_discounted_fare_4"
                            label="Special Discounted Fare 4"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.special_fare_5"
                            label="Special Fare 5"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field
                            v-model="editedItem.special_discounted_fare_5"
                            label="Special Discounted Fare 5"
                            :rules="[rules.number]"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-switch
                            color="primary"
                            v-model="editedItem.is_stop"
                            :label="`Stop: ${editedItem.is_stop ? editedItem.is_stop.toString() : false}`"
                          ></v-switch>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="closeEdit">Cancel</v-btn>
                  <v-btn color="blue darken-1" flat @click="saveEdit">Done</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="locationDialog" max-width="70.5vw">
              <v-card>
                <v-card-title>
                  <span class="headline text-uppercase">{{editedItem.name}}</span>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="closeLocation">Cancel</v-btn>
                  <v-btn color="blue darken-1" flat @click="saveLocation">Done</v-btn>
                </v-card-title>

                <!-- <v-card-text> -->
                <v-container fluid>
                  <v-layout wrap>
                    <v-flex md6>
                      <v-container>
                        <v-form ref="placeForm">
                          <!-- <v-text-field id="searchPlace" append-icon="search"></v-text-field> -->
                        </v-form>

                        <v-text-field v-model="stopPlot.lat" label="Latitude" readonly></v-text-field>
                        <v-text-field v-model="stopPlot.lng" label="Longatitude" readonly></v-text-field>

                        <v-slider
                          v-model="plotRadius"
                          label="Radius"
                          thumb-label="always"
                          :max="300"
                          :min="50"
                        ></v-slider>
                      </v-container>
                    </v-flex>
                    <v-flex md6>
                      <div>
                        <official-map
                          :center="center"
                          :zoom="zoom"
                          :radius="stopPlot.radius"
                          ref="map"
                          v-bind:style="{height: heightMap + 'vh', width: 'auto'}"
                          v-on:currentCenter="currentCenter"
                        ></official-map>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
                <!-- </v-card-text> -->

                <v-card-actions></v-card-actions>
              </v-card>
            </v-dialog>

            <delete-dialog
              :title="title"
              :type="deleteType"
              :deleteDialog="deleteDialog"
              @saveDeleteDialog="saveDeleteDialog"
              @closeDeleteDialog="closeDeleteDialog"
              :loading="confirmLoading"
            ></delete-dialog>
            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
              dialogType === 'edit' ? saveEditDialog() : 
              dialogType === 'add' ? saveAddDialog() :   
              dialogType === 'map' ? saveMapDialog() : ''"
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>
          </v-card-title>
          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <v-btn flat @click="openFilterExpansion">
                  <v-icon
                    class="mr-3"
                  >{{ openFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>
              </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >Row per Page:</p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="this.items.length < 10 ? true : false"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >{{ itemFrom + " -" + itemTo + " of " }} {{ totalItems }}</p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter">
            <v-flex md4></v-flex>
          </filter-panel>

          <v-data-table :headers="headers" :items="items" hide-actions disable-initial-sort>
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable', 
                    header.value === queryParams.order ? 'active' : '', 
                    'text-xs-'+header.align
                  ]"
                  @click="header.sortable ? changeSort(header) : ''"
                >
                  {{ header.text }}
                  <v-icon
                    small
                    v-if="header.sortable"
                  >{{ header.sortNum === 1 ? "arrow_downward" : "arrow_upward"}}</v-icon>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.index + queryParams.offset + 1}}</td>
              <td class="text-xs-left text-uppercase">{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.code }}</td>
              <!-- <td class="text-xs-right">{{ $amountInPeso(props.item.max_regular_fare) }}</td> -->
              <!-- <td class="text-xs-right">{{ $amountInPeso(props.item.max_discounted_fare) }}</td> -->
              <td class="text-no-wrap text-xs-center">
                <view-button @view="openViewDialog(props.item)"></view-button>
                <edit-button
                  v-if="$moduleAccess('edit_farematrix')"
                  @edit="openEditDialog(props.item)"
                ></edit-button>
                <download-item-button
                  v-if="$moduleAccess('download_kmpost_farematrix')"
                  @download="openDownloadStop(props.item)"
                  :loading="props.item.id === loadId"
                  :disabled="disableDL"
                  title="Download KM Posts"
                ></download-item-button>
                <v-tooltip top>
                  <v-btn
                    v-if="$moduleAccess('plot_stop_farematrix')"
                    icon
                    slot="activator"
                    @click="openStopMap(props.item)"
                  >
                    <v-icon color="red">pin_drop</v-icon>
                  </v-btn>
                  <span>Map</span>
                </v-tooltip>

                <delete-button
                  v-if="$moduleAccess('delete_farematrix')"
                  @delete="openDeleteDialog(props.item)"
                ></delete-button>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";
import DetailsContainer from "@/components/details_container/FareMatrixDetailsContainer";
import UploadCsv from "@/components/UploadCSV";
import FareMatrixData from "@/components/FareMatrixData";
import FareMatrixMap from "@/components/FareMatrixMap";
import OfficialMap from "@/components/OfficialMap";
var jsonexport = require("jsonexport");

export default {
  components: {
    DetailsContainer,
    UploadCsv,
    FareMatrixData,
    FareMatrixMap,
    OfficialMap
  },
  data() {
    return {
      openFilter: false,
      title: "Price Chart",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true
        },
        {
          text: "Code",
          align: "left",
          value: "code",
          sortable: false
        },
        // {
        //   text: "Max Regular Fare",
        //   align: "right",
        //   value: "max_regular_fare",
        //   sortable: false
        // },
        // {
        //   text: "Max Discounted Fare",
        //   align: "right",
        //   value: "max_discounted_fare",
        //   sortable: false
        // },
        {
          text: "Action",
          align: "center",
          sortable: false
        }
      ],
      items: [],
      queryParams: {
        search: "",
        limit: 10,
        offset: 0,
        order: "",
        desc: false,
        company_id: null,
        sub_company_id: null
      },
      dialogType: "",
      dialogStatus: false,
      openConfirmDialog: false,
      viewData: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 }
      ],
      routes: [],
      vehicleLayouts: [],
      passengerTypes: [],
      uploadItems: [],
      uploadHeaders: [],
      uploadHeadersDefault: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Name",
          align: "left",
          value: "name",
          sortable: true
        },
        {
          text: "Post",
          align: "right",
          value: "post",
          sortable: false
        },
        {
          text: "Province",
          align: "left",
          value: "province",
          sortable: false
        },
        {
          text: "Stop",
          align: "center",
          value: "stop",
          sortable: false
        },
        {
          text: "Regular Fare",
          align: "right",
          value: "regular_fare",
          sortable: false
        },
        {
          text: "Discounted Fare",
          align: "right",
          value: "discounted_fare",
          sortable: false
        },
        {
          text: "Special Fare",
          align: "right",
          value: "special_fare",
          sortable: false
        },
        {
          text: "Special Discounted Fare",
          align: "right",
          value: "special_discounted_fare",
          sortable: false
        },
        {
          text: "Special Fare 2",
          align: "right",
          value: "special_fare_2",
          sortable: false
        },
        {
          text: "Special Discounted Fare 2",
          align: "right",
          value: "special_discounted_fare_2",
          sortable: false
        },
        {
          text: "Special Fare 3",
          align: "right",
          value: "special_fare_3",
          sortable: false
        },
        {
          text: "Special Discounted Fare 3",
          align: "right",
          value: "special_discounted_fare_3",
          sortable: false
        },
        {
          text: "Special Fare 4",
          align: "right",
          value: "special_fare_4",
          sortable: false
        },
        {
          text: "Special Discounted Fare 4",
          align: "right",
          value: "special_discounted_fare_4",
          sortable: false
        },
        {
          text: "Special Fare 5",
          align: "right",
          value: "special_fare_5",
          sortable: false
        },
        {
          text: "Special Discounted Fare 5",
          align: "right",
          value: "special_discounted_fare_5",
          sortable: false
        }
      ],
      disabledSave: true,
      editDialog: false,
      locationDialog: false,
      editedIndex: -1,
      editedItem: {},
      editedItems: [],
      valid: true,
      rules: {
        number: value => !isNaN(value) || "Must be number."
      },
      loadId: null,
      disableDL: false,
      center: { lat: 14.4910735, lng: 120.9921169 },
      zoom: 14,
      heightMap: 0,
      stopPlot: {
        lat: 14.4910735,
        lng: 120.9921169,
        radius: 200
      },
      customizeDialog: false,

      mapPosts: [],
      postSelected: null
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      }
    },
    plotRadius: {
      get() {
        return this.stopPlot.radius;
      },
      set(val) {
        this.$refs.map.changeCircleRadius(val * 10);
      }
    }
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        this.queryParams.company_id = this.$store.state.company.id;
        this.queryParams.sub_company_id = this.$store.state.subcompany.id;

        let response = (await Services.getFareMatrixs(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async backClickFareMatrix(offset, limit) {
      this.uploadItems = await this.$store.state.fareMatrixItems.slice(
        offset,
        limit
      );
    },
    async nextClickFareMatrix(offset, limit) {
      this.uploadItems = await this.$store.state.fareMatrixItems.slice(
        offset,
        limit
      );
    },
    async setDataQueryLimit(offset, limit) {
      this.uploadItems = await this.$store.state.fareMatrixItems.slice(
        offset,
        limit
      );
    },
    async setData(id, offset, limit) {
      var data = {};
      try {
        const response = await Services.getFareMatrix(id);
        data = await response.data;
        data.name = data.name ? data.name.toUpperCase() : "";
        data.km_posts = await data.km_posts.sort((first, next) => {
          return first.post > next.post ? 1 : -1;
        });
        this.$store.dispatch("dispatchFareMatrixItems", data.km_posts);
        data.km_posts = data.km_posts
          ? this.$store.state.fareMatrixItems.slice(offset, limit)
          : "";
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      return data;
    },
    async setRoutes() {
      this.routes = [];
      const items = (
        await Services.getRoutes({
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id
        })
      ).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].id
        };

        this.routes.push(data);
      }
    },
    async setVehicleLayouts() {
      this.vehicleLayouts = [];
      const items = (
        await Services.getVehicleLayouts({
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id
        })
      ).data;
      for (var i = 0, el = items.data; i < el.length; i++) {
        let data = {
          text: el[i].name.toUpperCase(),
          value: el[i].vehicle_layout_id
        };

        this.vehicleLayouts.push(data);
      }
    },
    async changeSort(column) {
      this.queryParams.offset = 0;
      if (this.queryParams.order === column.value) {
        column.sortNum++;
        if (column.sortNum === 1) {
          this.queryParams.desc = true;
        }
        if (column.sortNum === 2) {
          column.sortNum = 0;
          this.queryParams.desc = false;
          this.queryParams.order = "";
        }
      } else {
        this.queryParams.order = column.value;
        this.queryParams.desc = false;
        column.sortNum = 0;
      }
      for (let i = 0; i < this.headers.length; i++) {
        if (this.headers[i].value === column.value) {
          this.headers[i].sortNum = column.sortNum;
        }
      }
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";

      this.uploadHeaders = this.uploadHeadersDefault;

      this.dialogStatus = true;

      this.setRoutes();
      this.setVehicleLayouts();

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;
      this.dialogType = "view";
      this.uploadHeaders = this.uploadHeadersDefault;
      this.dialogStatus = true;
      this.setRoutes();
      this.setVehicleLayouts();
      this.viewData = await this.setData(
        data.id,
        this.$refs.fareMatrixDataRef.queryParams.offset,
        this.$refs.fareMatrixDataRef.queryParams.limit
      );
      this.uploadItems = await this.viewData.km_posts.map(kmpost => {
        return {
          name: kmpost.name,
          post: kmpost.post,
          province: kmpost.province,
          is_stop: kmpost.is_stop,
          regular_fare: kmpost.regular_fare,
          discounted_fare: kmpost.discounted_fare,
          special_fare: kmpost.special_fare,
          special_discounted_fare: kmpost.special_discounted_fare,
          special_fare_2: kmpost.special_fare_2,
          special_discounted_fare_2: kmpost.special_discounted_fare_2,
          special_fare_3: kmpost.special_fare_3,
          special_discounted_fare_3: kmpost.special_discounted_fare_3,
          special_fare_4: kmpost.special_fare_4,
          special_discounted_fare_4: kmpost.special_discounted_fare_4,
          special_fare_5: kmpost.special_fare_5,
          special_discounted_fare_5: kmpost.special_discounted_fare_5
        };
      });
      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openEditDialog(data) {
      this.dialogLoading = true;
      this.dialogType = "edit";
      const header = [
        {
          text: "Action",
          align: "center",
          sortable: false
        }
      ];
      this.uploadHeaders = header.concat(this.uploadHeadersDefault);
      this.dialogStatus = true;
      this.setRoutes();
      this.setVehicleLayouts();
      this.viewData = await this.setData(
        data.id,
        this.$refs.fareMatrixDataRef.queryParams.offset,
        this.$refs.fareMatrixDataRef.queryParams.limit
      );
      this.uploadItems = await this.viewData.km_posts.map(kmpost => {
        return {
          name: kmpost.name,
          post: kmpost.post,
          province: kmpost.province,
          is_stop: kmpost.is_stop,
          regular_fare: kmpost.regular_fare,
          discounted_fare: kmpost.discounted_fare,
          special_fare: kmpost.special_fare,
          special_discounted_fare: kmpost.special_discounted_fare,
          special_fare_2: kmpost.special_fare_2,
          special_discounted_fare_2: kmpost.special_discounted_fare_2,
          special_fare_3: kmpost.special_fare_3,
          special_discounted_fare_3: kmpost.special_discounted_fare_3,
          special_fare_4: kmpost.special_fare_4,
          special_discounted_fare_4: kmpost.special_discounted_fare_4,
          special_fare_5: kmpost.special_fare_5,
          special_discounted_fare_5: kmpost.special_discounted_fare_5
        };
      });
      this.disabledSave = false;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },

    // async openEditDialog(data) {
    //   this.dialogLoading = true;
    //   this.dialogType = "edit";
    //   const header = [
    //     {
    //       text: "Action",
    //       align: "center",
    //       sortable: false
    //     }
    //   ];
    //   this.uploadHeaders = await header.concat(this.uploadHeadersDefault);
    //   this.dialogStatus = true;
    //   this.dialogLoading = true;
    //   this.dialogStatus = true;
    //   this.setRoutes();
    //   this.setVehicleLayouts();
    //   this.viewData = await this.setData(
    //     data.id,
    //     this.$refs.fareMatrixDataRef.queryParams.offset,
    //     this.$refs.fareMatrixDataRef.queryParams.limit
    //   );
    //   this.uploadItems = await this.viewData.km_posts.map(kmpost => {
    //     return {
    //       id: kmpost.id,
    //       name: kmpost.name,
    //       post: kmpost.post,
    //       province: kmpost.province,
    //       is_stop: kmpost.is_stop,
    //       regular_fare: kmpost.regular_fare,
    //       discounted_fare: kmpost.discounted_fare,
    //       special_fare: kmpost.special_fare,
    //       special_discounted_fare: kmpost.special_discounted_fare,
    //       special_fare_2: kmpost.special_fare_2,
    //       special_discounted_fare_2: kmpost.special_discounted_fare_2,
    //       special_fare_3: kmpost.special_fare_3,
    //       special_discounted_fare_3: kmpost.special_discounted_fare_3,
    //       special_fare_4: kmpost.special_fare_4,
    //       special_discounted_fare_4: kmpost.special_discounted_fare_4,
    //       special_fare_5: kmpost.special_fare_5,
    //       special_discounted_fare_5: kmpost.special_discounted_fare_5
    //     };
    //   });
    //   this.disabledSave = false;
    //   setTimeout(() => {
    //     this.dialogLoading = false;
    //   }, 600);
    // },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.viewData.id = data.id;
    },
    saveDialog() {
      if (this.dialogType == "map") {
        this.openConfirmDialog = true;
      } else {
        // Condition Form Required Form Validation
        if (this.$refs.detailsRef.validateForm()) {
          this.openConfirmDialog = true;
        }
      }
    },
    saveUpDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveAddDialog() {
      this.confirmLoading = true;
      const data = this.$refs.detailsRef.computedData,
        body = {
          name: data.name,
          code: data.code,
          route_id: data.route_id,
          vehicle_layout_id: data.vehicle_layout_id,
          km_posts: this.$store.state.fareMatrixItems,
          max_regular_fare: this.$store.state.fareMatrixItems[
            this.$store.state.fareMatrixItems.length - 1
          ].regular_fare,
          max_discounted_fare: this.$store.state.fareMatrixItems[
            this.$store.state.fareMatrixItems.length - 1
          ].discounted_fare,
          company_id: this.$store.state.company.id,
          sub_company_id: this.$store.state.subcompany.id
        };

      try {
        const response = await Services.addFareMatrix(body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Price Chart has been added!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: error.response.data.message
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveEditDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData,
        body = {
          name: data.name,
          code: data.code,
          route_id: data.route_id,
          vehicle_layout_id: data.vehicle_layout_id,
          km_posts: this.$store.state.fareMatrixItems,
          max_regular_fare: this.$store.state.fareMatrixItems[
            this.$store.state.fareMatrixItems.length - 1
          ].regular_fare,
          max_discounted_fare: this.$store.state.fareMatrixItems[
            this.$store.state.fareMatrixItems.length - 1
          ].discounted_fare
        };
      try {
        const response = await Services.editFareMatrix(data.id, body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Price Chart has been updated!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: error.response.data.message
          });
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteFareMatrix(this.viewData.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Price Chart has been deleted!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.confirmLoading = false;
    },
    async closeDialog() {
      this.$refs.fareMatrixDataRef.queryParams.offset = 0;
      this.$refs.fareMatrixDataRef.queryParams.limit = 10;
      this.$store.dispatch("dispatchFareMatrixItems", []);
      this.viewData = {};
      this.editedItems = [];
      this.uploadHeaders = [];
      this.uploadItems = [];
      if (this.dialogLoading === false) {
        this.$refs.detailsRef.clear();
      }

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
    },
    async downloadTemplate() {
      let rename = [
        "NAME",
        "POST",
        "PROVINCE",
        "STOP",
        "REGULAR FARE",
        "DISCOUNTED FARE",
        "SPECIAL FARE",
        "SPECIAL DISCOUNTED FARE",
        "SPECIAL FARE 2",
        "SPECIAL DISCOUNTED FARE 2",
        "SPECIAL FARE 3",
        "SPECIAL DISCOUNTED FARE 3",
        "SPECIAL FARE 4",
        "SPECIAL DISCOUNTED 4",
        "SPECIAL FARE 5",
        "SPECIAL DISCOUNTED 5"
      ];

      var values = [];
      for (let r = 0; r < rename.length; r++) {
        values.push("");
      }
      var object = Object.assign({}, values);
      var data = [];
      data.push(object);

      this.downloadCsv(data, rename, "kmposts_template.csv");
    },
    async downloadCsv(values, rename, filename) {
      jsonexport(values, { rename }, function(err, CSV) {
        if (err) return console.log(err);
        var data, link;
        var csv = CSV;
        if (csv == null) return;
        if (!csv.match(/^data:text\/csv/i)) {
          csv = "data:text/csv;charset=utf-8," + csv;
        }
        data = encodeURI(csv);
        link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", filename);
        link.click();
      });
    },
    async uploadCsv(data) {
      var strDelimiter = strDelimiter || ",";
      var objPattern = new RegExp(
        "(\\" +
          strDelimiter +
          "|\\r?\\n|\\r|^)" +
          '(?:"([^"]*(?:""[^"]*)*)"|' +
          '([^"\\' +
          strDelimiter +
          "\\r\\n]*))",
        "gi"
      );
      const arrData = [[]];
      var arrMatches = null;
      var strMatchedValue = "";
      if (data !== "") {
        while ((arrMatches = objPattern.exec(data))) {
          var strMatchedDelimiter = arrMatches[1];
          if (
            strMatchedDelimiter.length &&
            strMatchedDelimiter !== strDelimiter
          ) {
            arrData.push([]);
          }
          if (arrMatches[2]) {
            strMatchedValue = arrMatches[2].replace(new RegExp('""', "g"), '"');
          } else {
            strMatchedValue = arrMatches[3];
          }
          arrData[arrData.length - 1].push(strMatchedValue);
        }
      }

      let heads = [
        "name",
        "post",
        "province",
        "is_stop",
        "regular_fare",
        "discounted_fare",
        "special_fare",
        "special_discounted_fare",
        "special_fare_2",
        "special_discounted_fare_2",
        "special_fare_3",
        "special_discounted_fare_3",
        "special_fare_4",
        "special_discounted_fare_4",
        "special_fare_5",
        "special_discounted_fare_5"
      ];

      let headObject = Object.assign({}, heads);

      var array = arrData;
      var len = array.length - 1;

      var objArray = [];
      for (var i = 1; i < len; i++) {
        objArray[i - 1] = {};
        var header = [];
        header.push(headObject);

        for (var e = 1; e < len; e++) {
          objArray[e - 1] = {};
          for (var k = 0; k < array[0].length && k < array[e].length; k++) {
            var key = header[0][k];
            objArray[e - 1][key] = array[e][k];
          }
          for (var l = 0; l < array[0].length && l < array[e].length; l++) {
            var key1 = header[0][l];
            objArray[e - 1][key1] = array[e][l];
          }
        }
      }
      var json = JSON.stringify(objArray);
      let str = json.replace(/},/g, "},\r\n");
      if (array[0].length !== heads.length) {
        this.disableSaveUpload = true;
        this.uploadItems = [];
        this.$infoBar({
          type: "error",
          text: "Column not matched!"
        });
      } else {
        this.disabledSave = false;
        let uploads = JSON.parse(str);

        const uploadItems = [];
        if (uploads.length > 0) {
          uploads.map(item => {
            let upItem = {
              name: item.name ? item.name : "",
              post: item.post ? parseFloat(item.post) : 0,
              province: item.province,
              is_stop: item.is_stop
                ? item.is_stop.toLowerCase() === "true"
                : false,
              regular_fare: item.regular_fare
                ? parseFloat(item.regular_fare)
                : 0,
              discounted_fare: item.discounted_fare
                ? parseFloat(item.discounted_fare)
                : 0,
              special_fare: item.special_fare
                ? parseFloat(item.special_fare)
                : 0,
              special_discounted_fare: item.special_discounted_fare
                ? parseFloat(item.special_discounted_fare)
                : 0,
              special_fare_2: item.special_fare_2
                ? parseFloat(item.special_fare_2)
                : 0,
              special_discounted_fare_2: item.special_discounted_fare_2
                ? parseFloat(item.special_discounted_fare_2)
                : 0,
              special_fare_3: item.special_fare_3
                ? parseFloat(item.special_fare_3)
                : 0,
              special_discounted_fare_3: item.special_discounted_fare_3
                ? parseFloat(item.special_discounted_fare_3)
                : 0,
              special_fare_4: item.special_fare_4
                ? parseFloat(item.special_fare_4)
                : 0,
              special_discounted_fare_4: item.special_discounted_fare_4
                ? parseFloat(item.special_discounted_fare_4)
                : 0,
              special_fare_5: item.special_fare_5
                ? parseFloat(item.special_fare_5)
                : 0,
              special_discounted_fare_5: item.special_discounted_fare_5
                ? parseFloat(item.special_discounted_fare_5)
                : 0
            };
            uploadItems.push(upItem);
          });

          this.$store.dispatch("dispatchFareMatrixItems", await uploadItems);

          this.setDataQueryLimit(0, 10);
        } else {
          this.$infoBar({
            type: "error",
            text: "No data on CSV file"
          });
        }
      }
    },
    editItem(item) {
      this.editedIndex = this.uploadItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editDialog = true;
    },
    async stopLocation(data) {
      this.locationDialog = true;

      this.heightMap = 71;

      this.$refs.placeForm.reset();

      await this.$refs.map.initializeMap();

      await this.$refs.map.addMarker(this.stopPlot);

      await this.$refs.map.autoComplete();

      // let getTerminal = (await Services.getTerminal(data)).data;
      // await this.$refs.terminalMap.initMapTerminal(getTerminal);

      this.editedIndex = this.uploadItems.indexOf(data);
      this.editedItem = Object.assign({}, data);
    },
    currentCenter(data) {
      this.stopPlot = data;
    },
    closeEdit() {
      this.editDialog = false;
      setTimeout(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      }, 300);
    },
    closeLocation() {
      this.locationDialog = false;
      setTimeout(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      }, 300);
    },
    async saveEdit() {
      this.dialogLoading = true;
      this.editedItem.post = this.editedItem.post
        ? parseFloat(this.editedItem.post)
        : 0;
      this.editedItem.regular_fare = this.editedItem.regular_fare
        ? parseFloat(this.editedItem.regular_fare)
        : 0;
      this.editedItem.discounted_fare = this.editedItem.discounted_fare
        ? parseFloat(this.editedItem.discounted_fare)
        : 0;
      this.editedItem.special_fare = this.editedItem.special_fare
        ? parseFloat(this.editedItem.special_fare)
        : 0;
      this.editedItem.special_discounted_fare = this.editedItem
        .special_discounted_fare
        ? parseFloat(this.editedItem.special_discounted_fare)
        : 0;
      this.editedItem.special_fare_2 = this.editedItem.special_fare_2
        ? parseFloat(this.editedItem.special_fare_2)
        : 0;
      this.editedItem.special_discounted_fare_2 = this.editedItem
        .special_discounted_fare_2
        ? parseFloat(this.editedItem.special_discounted_fare_2)
        : 0;
      this.editedItem.special_fare_3 = this.editedItem.special_fare_3
        ? parseFloat(this.editedItem.special_fare_3)
        : 0;
      this.editedItem.special_discounted_fare_3 = this.editedItem
        .special_discounted_fare_3
        ? parseFloat(this.editedItem.special_discounted_fare_3)
        : 0;
      this.editedItem.special_fare_4 = this.editedItem.special_fare_4
        ? parseFloat(this.editedItem.special_fare_4)
        : 0;
      this.editedItem.special_discounted_fare_4 = this.editedItem
        .special_discounted_fare_4
        ? parseFloat(this.editedItem.special_discounted_fare_4)
        : 0;
      this.editedItem.special_fare_5 = this.editedItem.special_fare_5
        ? parseFloat(this.editedItem.special_fare_5)
        : 0;
      this.editedItem.special_discounted_fare_5 = this.editedItem
        .special_discounted_fare_5
        ? parseFloat(this.editedItem.special_discounted_fare_5)
        : 0;

      Object.assign(this.uploadItems[this.editedIndex], this.editedItem);

      this.$store.dispatch("editFareMatrixItems", {
        index: this.editedIndex,
        item: this.editedItem
      });

      const items = [];

      await this.editedItems.map(item => {
        if (item.id !== this.editedItem.id) {
          items.push(item);
        }
      });

      items.push(this.editedItem);
      this.editedItems = await items;
      this.closeEdit();

      this.dialogLoading = false;
    },
    async saveLocation() {
      this.dialogLoading = true;

      await this.editedItems.map(item => {
        if (item.id !== this.editedItem.id) {
          items.push(item);
        }
      });

      items.push(this.editedItem);
      this.editedItems = await items;
      this.closeEdit();

      this.dialogLoading = false;
    },
    async openDownloadStop(data) {
      this.disableDL = await true;
      this.loadId = await data.id;
      this.viewData = await this.setData(data.id);

      let rename = [
        "NAME",
        "POST",
        "PROVINCE",
        "STOP",
        "REGULAR FARE",
        "DISCOUNTED FARE",
        "SPECIAL FARE",
        "SPECIAL DISCOUNTED FARE",
        "SPECIAL FARE 2",
        "SPECIAL DISCOUNTED FARE 2",
        "SPECIAL FARE 3",
        "SPECIAL DISCOUNTED FARE 3",
        "SPECIAL FARE 4",
        "SPECIAL DISCOUNTED 4",
        "SPECIAL FARE 5",
        "SPECIAL DISCOUNTED 5"
      ];

      var values = [];

      values = await this.viewData.km_posts.map(km_post => {
        return {
          name: km_post.name,
          post: km_post.post,
          province: km_post.province,
          is_stop: km_post.is_stop,
          regular_fare: km_post.regular_fare,
          discounted_fare: km_post.discounted_fare,
          special_fare: km_post.special_fare,
          special_discounted_fare: km_post.special_discounted_fare,
          special_fare_2: km_post.special_fare_2,
          special_discounted_fare_2: km_post.special_discounted_fare_2,
          special_fare_3: km_post.special_fare_3,
          special_discounted_fare_3: km_post.special_discounted_fare_3,
          special_fare_4: km_post.special_fare_4,
          special_discounted_fare_4: km_post.special_discounted_fare_4,
          special_fare_5: km_post.special_fare_5,
          special_discounted_fare_5: km_post.special_discounted_fare_5
        };
      });
      let filename = data.name + ".csv";
      await this.downloadCsv(values, rename, filename);

      this.loadId = await null;
      this.disableDL = await false;
      this.viewData = await {};
    },
    loadingDownload(data) {
      let item = null;
      return false;
    },
    refreshData() {
      this.$refs.searchRef.clear();
      this.getData();
    },
    async openStopMap(data) {
      this.dialogType = "map";

      this.$store.dispatch("startLoading");

      this.viewData = await this.setData(data.id);

      if (this.viewData.km_posts) {
        if (this.viewData.km_posts.length) {
          this.mapPosts = this.viewData.km_posts
            .filter(item => item.is_stop == true)
            .map((item, index) => {
              return {
                text: item.name,
                value: {
                  id: item.id,
                  index,
                  name: item.name,
                  post: item.post,
                  plot: item.area ? true : false,
                  lat: item.area ? item.area.lat : 14.4910735,
                  lng: item.area ? item.area.lng : 120.9921169,
                  radius: item.area ? item.area.radius : 500
                }
              };
            });
        }
      }

      this.$store.dispatch("endLoading");

      this.customizeDialog = true;

      this.$refs.mapMatrix.initMap();
    },
    disableSaveStopMap() {
      return this.mapPosts.some(item => !item.value.plot);
    },
    selectPost(data) {
      this.mapPosts[data.index].value.plot = true;
    },
    setLocation(data, location) {
      this.mapPosts[data.index].value.lat = location.lat;
      this.mapPosts[data.index].value.lng = location.lng;
    },
    setRadius(data, radius) {
      this.mapPosts[data.index].value.radius = radius;
    },
    async saveMapDialog() {
      const body = this.mapPosts
        .map(item => item.value)
        .filter(item => item.plot)
        .map(item => {
          const { id, lat, lng, radius } = item;
          return { id, area: { lat, lng, radius } };
        });

      try {
        const response = await Services.plotFareMatrix(body);

        if (response.status === 201 || response.status === 204) {
          this.closeMapDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Plot has been saved!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: error.response.data.message
          });
        }
      }
      this.confirmLoading = await false;
    },
    closeMapDialog() {
      this.closeConfirmDialog();

      this.mapPosts = [];
      this.postSelected = null;
      this.customizeDialog = false;

      this.$refs.mapMatrix.clear();
    }
  }
};
</script>

<style scoped>
/* .scrolling-wrapper {
  overflow-x: hidden;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
  max-width: 1200px;
} */
</style>
